import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import LeaderboardPage from "@/pages/LeaderboardPage";
import BattlePage from "@/pages/BattlePage";
import SubmitClipPage from "@/pages/SubmitClipPage";
import ClipDetailPage from "@/pages/ClipDetailPage";
import ComediansPage from "@/pages/ComediansPage";
import AuthPage from "@/pages/AuthPage";
import ProfilePage from "@/pages/ProfilePage";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="min-h-screen">
          <Navbar />
          <main data-testid="app-main">
            <Routes>
              <Route path="/" element={<LeaderboardPage />} />
              <Route path="/battle" element={<BattlePage />} />
              <Route path="/submit" element={<SubmitClipPage />} />
              <Route path="/clip/:id" element={<ClipDetailPage />} />
              <Route path="/comedians" element={<ComediansPage />} />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/user/:id" element={<ProfilePage />} />
              <Route path="/login" element={<AuthPage mode="login" />} />
              <Route path="/register" element={<AuthPage mode="register" />} />
            </Routes>
          </main>
          <Toaster theme="dark" position="top-right" richColors />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
